import { getTradeTime } from '@/api/fetch-utils/trade';
import { getRequest } from '@/lib/axios';
import { useFetch } from '@/lib/fetch-tools';
import { convertTradeTime } from '@/pages/trade/components/tradeBox/component/convertTradeTime';
import { signal } from '@preact-signals/safe-react';
import { useEffect, useState } from 'react';

export const tradeTimeDataSignal = signal<any>();

export const useTradeTime = () => {
  const { data: tradeTime, refetch: refetchTradeTime } = useFetch(getTradeTime);

  useEffect(() => {
    const timer = setInterval(() => {
      //   refreshApi(getTradeTime);
      refetchTradeTime().then((res) => {
        const tradeTimeData = res?.data;
        if (tradeTimeData) {
          tradeTimeDataSignal.value = convertTradeTime(
            tradeTimeData.currentTime,
            tradeTimeData.tradeTimeList
          );
        }
      });
    }, 1000 * 10);

    return () => (timer ? clearInterval(timer) : undefined);
  }, [refetchTradeTime]);
  useEffect(() => {
    const fetchAxios = () => {
      getRequest('/api/pc/trade/getTime').then((res) => {
        const tradeTimeData = res?.data;

        if (tradeTimeData) {
          tradeTimeDataSignal.value = convertTradeTime(
            tradeTimeData.currentTime,
            tradeTimeData.tradeTimeList
          );            
        }
      });
    };
    const timer = setInterval(() => {
      fetchAxios();
    }, 1000 * 10);
    fetchAxios();

    return () => (timer ? clearInterval(timer) : undefined);
  }, []);

  return {
    timeData: tradeTimeDataSignal,
  };
};
